module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mx-0 contacts"
  }, [_c('div', {
    staticClass: "col-12 col-md-6 col-lg-3 justify-content-center"
  }, [_c('div', {
    staticClass: "contacts__logo mb-3"
  }, [(_vm.data.logo_image) ? _c('AppPicture', {
    attrs: {
      "image": _vm.data.logo_image,
      "image-width": "100px",
      "image-height": "100px"
    }
  }) : _vm._e()], 1), (_vm.data.portal_title) ? _c('div', {
    staticClass: "contacts__title"
  }, [_vm._v(_vm._s(_vm.data.portal_title))]) : _vm._e()]), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [(_vm.data.links && _vm.data.links.length) ? _c('ul', {
    staticClass: "d-flex flex-column contacts__links"
  }, _vm._l((_vm.data.links), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "mb-3"
    }, [_c('a', {
      attrs: {
        "href": item.url
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [(_vm.data.privacy_policy_file_url) ? _c('a', {
    staticClass: "mb-3 d-block",
    attrs: {
      "href": _vm.data.privacy_policy_file_url
    }
  }, [_vm._v("Правила сайта и политика конфиденциальности")]) : _vm._e(), (_vm.data.org_name) ? _c('p', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.data.org_name))]) : _vm._e(), (_vm.data.OGRN) ? _c('p', {
    staticClass: "mb-3"
  }, [_vm._v("ОГРН " + _vm._s(_vm.data.OGRN))]) : _vm._e(), (_vm.data.INN) ? _c('p', {
    staticClass: "mb-3"
  }, [_vm._v("ИНН " + _vm._s(_vm.data.INN))]) : _vm._e(), (_vm.data.address) ? _c('p', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.data.address))]) : _vm._e()]), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [(_vm.data.contact_email) ? _c('a', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "href": ("mailto:" + (_vm.data.contact_email))
    }
  }, [_c('AppSvgIcon', {
    staticClass: "ui_color__black me-2",
    attrs: {
      "manual-width": "40px",
      "manual-height": "40px",
      "color-mode": "stroke",
      "template": _vm.$ui.IconSvgComponents.email
    }
  }), _vm._v(_vm._s(_vm.data.contact_email))], 1) : _vm._e(), _vm._l((_vm.data.contact_phone ? _vm.data.contact_phone.split(",") : []), function(item, index) {
    return [(item.trim()) ? _c('a', {
      staticClass: "d-flex align-items-center",
      attrs: {
        "href": ("tel:" + (item.trim()))
      }
    }, [_c('AppSvgIcon', {
      staticClass: "ui_color__black me-2",
      attrs: {
        "manual-width": "40px",
        "manual-height": "40px",
        "color-mode": "stroke",
        "template": _vm.$ui.IconSvgComponents.phone
      }
    }), _vm._v(_vm._s(item.trim()))], 1) : _vm._e()]
  }), (_vm.data.code) ? _c('div', {
    ref: "code",
    staticClass: "d-flex flex-column",
    domProps: {
      "innerHTML": _vm._s(_vm.data.code)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "social_networks-box"
  }, [_c('a', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "href": _vm.data.telegram_url
    }
  }, [(_vm.data.telegram_url) ? _c('AppSvgIcon', {
    staticClass: "ui_color__black me-2",
    attrs: {
      "manual-width": "35px",
      "manual-height": "35px",
      "color-mode": "fill",
      "template": _vm.$ui.IconSvgComponents.telegram
    }
  }) : _vm._e()], 1), _c('a', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "href": _vm.data.vk_url
    }
  }, [(_vm.data.vk_url) ? _c('AppSvgIcon', {
    staticClass: "ui_color__black me-2",
    attrs: {
      "manual-width": "35px",
      "manual-height": "35px",
      "color-mode": "fill",
      "template": _vm.$ui.IconSvgComponents.vk
    }
  }) : _vm._e()], 1), _c('a', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "href": _vm.data.rutube_url
    }
  }, [(_vm.data.rutube_url) ? _c('AppSvgIcon', {
    staticClass: "ui_color__black me-2",
    attrs: {
      "manual-width": "35px",
      "manual-height": "35px",
      "color-mode": "fill",
      "template": _vm.$ui.IconSvgComponents.rutube
    }
  }) : _vm._e()], 1), _c('a', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "href": _vm.data.dzen_url
    }
  }, [(_vm.data.dzen_url) ? _c('AppSvgIcon', {
    staticClass: "ui_color__black me-2",
    attrs: {
      "manual-width": "35px",
      "manual-height": "35px",
      "color-mode": "fill",
      "template": _vm.$ui.IconSvgComponents.dzen
    }
  }) : _vm._e()], 1), _c('a', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "href": _vm.data.ok_url
    }
  }, [(_vm.data.ok_url) ? _c('AppSvgIcon', {
    staticClass: "ui_color__black me-2",
    attrs: {
      "manual-width": "35px",
      "manual-height": "35px",
      "color-mode": "fill",
      "template": _vm.$ui.IconSvgComponents.odnoklassniki
    }
  }) : _vm._e()], 1)])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-636a61f7","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/sections/contacts/Contacts.vue
// module id = 98937562dcb290766297
// module chunks = 0